import React, { useState } from 'react';
import FleetAnalyticsDashboard from './FleetAnalyticsDashboard';
import MbbTelemetryAIInsights from './MbbTelemetryAIInsights';
import ADTelemetry from './ADTelemetry';
import RTTLive from './RTTLive';
import RTTHistory from './RTTHistory';
import CrashAnalytics from './CrashAnalytics';
import ClientDebugAnalytics from './ClientDebugAnalytics';
import '../assets/AllTabsCommon.css';
import '../assets/FleetAnalytics.css';

const ANALYTICS_TABS = [
    { key: 'mbb',    label: '📊 MBB Telemetry' },
    { key: 'ad',     label: '🔍 AD Telemetry'  },
    { key: 'rt',     label: '🔁 RT Telemetry'  },
    { key: 'crash',  label: '💥 Crash'          },
    { key: 'client-debug', label: 'Client Debug' },
    { key: 'mbb-ai', label: '🤖 MBB Telemetry AI Insights' },
];

const RT_SUB_TABS = [
    { key: 'live',    label: '📡 Live'    },
    { key: 'history', label: '📋 History' },
];

function FleetHealthAnalytics({ userInfo, role, onNavigateToDeviceProfile, onNavigateToConfigurations }) {
    const [activeTab, setActiveTab]       = useState('mbb');
    const [activeRtSub, setActiveRtSub]   = useState('live');

    return (
        <div className="analytics-shell">
            {/* ── Top-level tab bar ── */}
            <div className="analytics-tabs" role="tablist" aria-label="Analytics views">
                {ANALYTICS_TABS.map((t) => (
                    <button
                        type="button"
                        role="tab"
                        aria-selected={activeTab === t.key}
                        key={t.key}
                        className={`analytics-tab${activeTab === t.key ? ' active' : ''}`}
                        onClick={() => setActiveTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {/* ── MBB Telemetry ── */}
            {activeTab === 'mbb' && (
                <FleetAnalyticsDashboard onDeviceClick={onNavigateToDeviceProfile} />
            )}

            {/* ── AD Telemetry ── */}
            {activeTab === 'ad' && (
                <ADTelemetry userInfo={userInfo} role={role} onNavigateToConfigurations={onNavigateToConfigurations} />
            )}

            {/* ── RT Telemetry (Live / History) ── */}
            {activeTab === 'rt' && (
                <div>
                    <div className="analytics-rt-sub-tabs">
                        {RT_SUB_TABS.map((t) => (
                            <button
                                key={t.key}
                                className={`analytics-rt-sub-tab${activeRtSub === t.key ? ' active' : ''}`}
                                onClick={() => setActiveRtSub(t.key)}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>
                    {activeRtSub === 'live'    && <RTTLive />}
                    {activeRtSub === 'history' && <RTTHistory />}
                </div>
            )}

            {/* ── Crash ── */}
            {activeTab === 'crash' && (
                <CrashAnalytics />
            )}

            {/* ── Client Debug ── */}
            {activeTab === 'client-debug' && (
                <ClientDebugAnalytics userInfo={userInfo} />
            )}

            {/* ── MBB Telemetry AI Insights ── */}
            {activeTab === 'mbb-ai' && (
                <MbbTelemetryAIInsights userInfo={userInfo} role={role} />
            )}
        </div>
    );
}

export default FleetHealthAnalytics;
